/** Curated OFL font bundle — self-hosted in surf-web/public/fonts. */
export const SURF_FONT_OPTIONS = [
    { id: "Surf Sans", label: "Sans (Inter)" },
    { id: "Surf Serif", label: "Serif (Source Serif 4)" },
    { id: "Surf Mono", label: "Mono (JetBrains Mono)" },
];
export const SURF_FONT_WEIGHTS = {
    sans: [400, 500, 600, 700, 800],
    serif: [400, 600, 700],
    mono: [400, 700],
};
const LEGACY_TO_CANONICAL = {
    "surf inter": "Surf Sans",
    "surf georgia": "Surf Serif",
    "surf courier": "Surf Mono",
    "system-ui": "Surf Sans",
    inter: "Surf Sans",
    georgia: "Surf Serif",
    serif: "Surf Serif",
    mono: "Surf Mono",
    courier: "Surf Mono",
    "courier new": "Surf Mono",
    "source serif 4": "Surf Serif",
    "jetbrains mono": "Surf Mono",
};
export function normalizeSurfFont(font) {
    const key = font.trim().toLowerCase();
    for (const opt of SURF_FONT_OPTIONS) {
        if (opt.id.toLowerCase() === key)
            return opt.id;
    }
    return LEGACY_TO_CANONICAL[key] ?? "Surf Sans";
}
export function surfFontFamilyKey(font) {
    const id = normalizeSurfFont(font);
    if (id === "Surf Serif")
        return "serif";
    if (id === "Surf Mono")
        return "mono";
    return "sans";
}
/** Snap requested weight to nearest bundled file (shared by CSS @font-face and PDF). */
export function snapSurfFontWeight(font, weight) {
    const available = SURF_FONT_WEIGHTS[surfFontFamilyKey(font)];
    let best = available[0];
    let bestDist = Infinity;
    for (const w of available) {
        const d = Math.abs(w - weight);
        if (d < bestDist) {
            bestDist = d;
            best = w;
        }
    }
    return best;
}
export function canvasFontStack(font) {
    const key = surfFontFamilyKey(font);
    if (key === "serif")
        return '"Surf Serif", serif';
    if (key === "mono")
        return '"Surf Mono", monospace';
    return '"Surf Sans", sans-serif';
}
/** jsPDF internal family key (one registered name per weight). */
export function pdfFamilyKey(font) {
    const key = surfFontFamilyKey(font);
    if (key === "serif")
        return "SurfSerif";
    if (key === "mono")
        return "SurfMono";
    return "SurfSans";
}
/** jsPDF font name after VFS registration — `${familyKey}-${snappedWeight}`. */
export function pdfEmbeddedFontName(font, weight) {
    return `${pdfFamilyKey(font)}-${snapSurfFontWeight(font, weight)}`;
}
/**
 * PowerPoint font face — real family name; PptxGenJS does not embed fonts.
 * Viewer must have the face installed for pixel parity.
 */
export function pptxSafeFontFace(font) {
    const key = surfFontFamilyKey(font);
    if (key === "serif")
        return "Source Serif 4";
    if (key === "mono")
        return "JetBrains Mono";
    return "Inter";
}
